<template>
  <div>
    <div>
      <div class="d-flex flex-row">
        <div style="width:80px;"></div>
        <div style="width:80px;" v-if="colCheckbox"></div>
        <div style="flex-grow:1;">Nom famille / produit</div>
        <div style="width:120px;">Produits</div>
        <div style="width:120px;">Actions</div>
        <div style="width:60px;" v-if="colProblems">Pb</div>
      </div>

      <div>
        <draggable
          tag="div"
          :list="flatArborescence"
          class="list-group"
          handle=".handle"
          :move="checkMove"
          @end="dragEnd($event)"
        >
          <div
            v-for="(node,index) in flatArborescence"
            :key="index"
            :id="node.type==='node'? 'node_'+node.id:'product_'+node.pr_id"
            :class="getClassLineColor(index, node)"
          >
            <div
              v-if="node.showed"
              @click="selectLine(node)"
              class="d-flex flex-row list-group-item"
              :class="getClassLine(index, node)"
            >
              <div style="flex-basis:80px; flex-shrink:0;" class>
                <div
                  v-if="node.name !== 'root' && (!node.opened || node.type=='product') && $store.state.myrights.create_catalogue"
                  class="icon-show-products ml-2 withpointer handle"
                >
                  <icon v-if="ca_id!==0" class="mr-2" name="list"></icon>
                </div>
              </div>
              <div
                v-if="colCheckbox && nodeSelected.level<node.level"
                style="flex-basis:80px; flex-shrink:0;"
              >
                <div class="col-checkbox" :style="'width:120px; text-align:center'">
                  <v-checkbox
                    :disabled="node.pr_id? true: false"
                    color="#fec90a"
                    class="checkbox-node-line"
                    hide-details
                    v-model="node.checked"
                    @change="checkedNode(node)"
                  ></v-checkbox>
                </div>
              </div>
              <div style="flex-grow:1;">
                <div v-if="node.id || node.id === 0">
                  <div class="family-name" :class="'level'+node.level ">
                    <div class="d-flex flex-row" @click.stop="open(node)" v-if="node.opened">
                      <icon class="mr-2" name="caret-down"></icon>
                      <icon class="mr-2" name="folder-open" :style="`color:${node.color};`"></icon>
                    </div>
                    <div class="d-flex flex-row" @click.stop="open(node)" v-if="!node.opened">
                      <icon class="mr-2" name="caret-right"></icon>
                      <icon class="mr-2" name="folder" :style="`color:${node.color};`"></icon>
                    </div>

                    <div>
                      {{getFamilylevel(node)}}
                      <span class="bis">{{getnodeName(node)}}</span>
                    </div>
                  </div>
                </div>
                <div v-if="node.pr_id" :class="'level'+node.level+' d-flex flex-row'">
                  <div v-if="colFamily">{{node.fa_parent}}</div>
                  <div
                    style="background-color:white; flex-basis:75px; flex-shrink:0; margin-top:-5px; margin-bottom:-5px;"
                  >
                    <v-img
                      :src="`${$config.server_url}/api/1.0/products/image/${node.pr_ref}/1/75/50?d=${now}`"
                      contain
                      height="50px"
                      width="75px"
                    ></v-img>
                  </div>
                  <div style="flex-basis:90px; flex-shrink:0;">
                    {{node.pr_marque}}
                    <br />
                    {{node.pr_ref}}
                  </div>
                  <div class="flex-grow-1" style="padding-right:10px;">{{node.pr_name_fr}}</div>
                  <div style="flex-basis:90px; flex-shrink:0;" v-if="node.pr_status">
                    <div>
                      <span class="bis">statut :</span>
                      {{node.pr_status}}
                    </div>
                  </div>
                  <div style="flex-basis:90px; flex-shrink:0;" v-if="node.pr_promo">
                    <div>
                      <span class="bis">promo :</span>
                      {{node.pr_promo}}
                    </div>
                  </div>
                </div>
              </div>
              <div style="flex-basis:120px; flex-shrink:0;">
                <div class="nombre-product d-flex flex-row" :style="'width:120px; text-align:left'">
                  <div>{{node.nbProducts}}</div>
                </div>
              </div>
              <div style="flex-basis:120px; flex-shrink:0;">
                <div :style="'width:120px; text-align:left'" class="d-flex flex-row">
                  <div
                    v-if="node.name !== 'root' && colEdit && node.id"
                    class="icon-show-products withpointer flex-same-size"
                    @click.stop="editLine(node.id, node.level, node.name)"
                  >
                    <icon class="mr-2" name="edit"></icon>
                  </div>
                  <div v-else class="flex-same-size">&nbsp;</div>
                  <div
                    v-if="(node.id || node.id===0) && $store.state.myrights.create_catalogue"
                    class="icon-show-products withpointer flex-same-size"
                    @click.stop="addProductToNode(node.id, node, node.name)"
                  >
                    <icon v-if="ca_id!==0" class="mr-2" name="plus"></icon>
                  </div>
                  <div v-else class="flex-same-size">&nbsp;</div>
                  <div
                    v-if="node.name !== 'root' && $store.state.myrights.create_catalogue"
                    class="icon-show-products withpointer flex-same-size"
                    @click.stop="deleteWinConfirm(node)"
                  >
                    <icon v-if="ca_id!==0" class="mr-2" name="trash"></icon>
                  </div>
                  <div v-else class="flex-same-size">&nbsp;</div>
                </div>
              </div>
              <div style="flex-basis:60px; flex-shrink:0;" v-if="colProblems">
                <v-toolbar-items class="col-problems ml-auto">
                  <v-menu
                    :open-on-hover="true"
                    :close-on-click="true"
                    :close-on-content-click="true"
                    :offset-y="true"
                  >
                    <template v-slot:activator="{ on }">
                      <div class="d-flex flex-row" v-if="node.nbProblems>0" v-on="on">
                        <div class="icon-show-products withpointer d-flex flex-row">
                          <icon class="mr-2" name="exclamation-triangle"></icon>
                          <div>{{node.nbProblems}}</div>
                        </div>
                      </div>
                    </template>
                    <div class="dropdown-pb">
                      <div
                        class="bis"
                        v-if="node.type=='node'"
                      >{{node.problems.length}} problèmes sur ce dossier :</div>
                      <div
                        class="bis"
                        v-if="node.type=='product'"
                      >{{node.problems.length}} problèmes sur ce produit :</div>
                      <div v-for="(pb, i) in node.problems" :key="i">{{pb.text}}</div>
                      <div v-if="node.type=='node'">
                        <br />
                        {{node.nbProblems - node.problems.length}} autres problèmes à l'intérieur du dossier
                      </div>
                    </div>
                  </v-menu>
                </v-toolbar-items>
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </div>
    <m-family-win-edit ref="familywinedit" @familyWinEditSaved="getCatalog" :ca_id="ca_id"></m-family-win-edit>
    <m-catalog-add-product ref="catalogaddproduct" @saved="getCatalog" :nodeSelected="nodeSelected"></m-catalog-add-product>
    <m-product-win-edit
      ref="productwinedit"
      @productWinEditSaved="getCatalog"
      @productWinEditCanceled="$emit('productWinEditCanceled')"
    ></m-product-win-edit>
    <m-confirm-dialog
      v-model="confirmDeleteNode"
      :text="`Souhaitez-vous vraiment effacer ${nodeTodelete} et tout ce que se trouve à l'intérieur?`"
      title="Confirmation"
      @canceled="confirmDeleteNode=false"
      @confirmed="deleteWinNode()"
    ></m-confirm-dialog>
    <m-confirm-dialog
      v-model="confirmDeleteProduct"
      :text="`Souhaitez-vous vraiment effacer ce produit : ${productTodelete} ?`"
      title="Confirmation"
      @canceled="confirmDeleteProduct=false"
      @confirmed="deleteWinProduct()"
    ></m-confirm-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "card-tree",
  components: {
    draggable
  },
  props: {
    ca_id: Number,
    colProblems: Boolean,
    colCheckbox: Boolean,
    colFamily: Boolean,
    colEdit: Boolean,
    path: String,
    allCheckboxCheccked: Boolean,
    catalogName: String,
    nodeSelected: Object,
    canSelectLine: Boolean
  },
  data() {
    return {
      updatenow: 0,

      //color: "whiteLine",
      indexLine: 0,
      confirmDeleteNode: false,
      nodeTodelete: "",
      confirmDeleteProduct: false,
      faIdToDelete: null,
      productTodelete: "",
      prIdToDelete: null,
      arborescence: { problems: [], children: [] },
      selectedNodeToAdd: [],
      nodeToAdd: {},

      flatArborescence: [],
      now: new Date().getTime(),
      currentSelection: null,
      nodeOpened: []
    };
  },
  mounted() {
    this.getCatalog();
  },
  destroyed() {},
  methods: {
    async getCatalog() {
      let params = {};
      let response = await this.$axios.get(
        this.$config.server_url +
          "/api/1.0/catalogs/" +
          this.ca_id +
          "/content",
        { params }
      );
      //console.warn("response.data.arborescence", response.data.arborescence); // à laisser !
      this.arborescence = response.data.arborescence;
      this.$emit("treeloaded", this.arborescence);
      this.$emit("changeDataCatalog");
      this.arborescence.showed = this.arborescence.opened;
      this.arborescence.type = "node";
      let flatArborescence = [this.arborescence];
      await this.createFlatArborescence(flatArborescence);
      this.flatArborescence = flatArborescence;
      this.open(this.flatArborescence[0]);
    },
    async createFlatArborescence(flatArborescence, nodeParent) {
      if (!nodeParent) {
        nodeParent = this.arborescence;
        for (let p = 0; p < nodeParent.products.length; p++) {
          const product = nodeParent.products[p];
          product.type = "product";
          product.showed = false;
          product.idParent = nodeParent.id;
          if (nodeParent.opened) product.showed = true;
          flatArborescence.push(product);
        }
      }
      for (let index = 0; index < nodeParent.children.length; index++) {
        const node = nodeParent.children[index];
        node.showed = node.opened;
        node.type = "node";
        node.idParent = nodeParent.id;
        flatArborescence.push(node);
        for (let p = 0; p < node.products.length; p++) {
          const product = node.products[p];
          product.type = "product";
          product.showed = false;
          product.idParent = node.id;
          if (node.opened) product.showed = true;
          flatArborescence.push(product);
        }
        await this.createFlatArborescence(flatArborescence, node);
      }
    },
    checkedNode(node) {
      for (let ipr = 0; ipr < node.products.length; ipr++) {
        const product = node.products[ipr];
        product.checked = node.checked;
      }
      for (let ino = 0; ino < node.children.length; ino++) {
        const child = node.children[ino];
        child.checked = node.checked;
        this.checkedNode(child);
      }
      this.rerender();
    },
    selectLine(child) {
      if (child.level === 3) return;
      // if (!this.canSelectLine) return;
      if (!child.id && child.id !== 0) {
        this.openProduct(child.pr_id);
        return;
      }
      this.currentSelection = child;
      this.$emit("enabledBtnCreateNode", child);
    },
    createLineFamily() {
      if (this.currentSelection) {
        this.$router.push(this.path + "/family/edit/-1");
        this.$refs.familywinedit.open(
          -1,
          this.currentSelection.level,
          "",
          this.ca_id,
          this.currentSelection
        );
      }
    },
    openProduct(pr_id) {
      this.$refs.productwinedit.open(pr_id);
    },
    getClassLine(index, node) {
      let classe = "line";
      classe += node.id ? " lineNode" : " lineProduct";
      classe +=
        this.currentSelection && this.currentSelection.id === node.id
          ? " selected"
          : "";
      // classe += node.indexLine % 2 === 0 ? " grayLine" : " whiteLine";
      return classe;
    },
    getClassLineColor(index, node) {
      let classe = "";
      classe += node.indexLine % 2 === 0 ? " grayLine" : " whiteLine";
      return classe;
    },
    getFamilylevel(child) {
      let family = "";
      if (child.id) {
        if (child.level === 1) family = "FAMILLE ";
        if (child.level === 2) family = "SOUS-FAMILLE ";
        if (child.level === 3) family = "SEGMENT ";
      }
      return family;
    },
    getnodeName(node) {
      if (this.ca_id === 0 && node.name === "root") return "Matrice";
      if (this.ca_id !== 0 && node.name === "root") return this.catalogName;
      else {
        return node.name;
      }
    },
    async open(node) {
      node.opened = !node.opened;
      if (node.opened) this.nodeOpened.push(node.id);
      else {
        this.$_.remove(this.nodeOpened, function(id) {
          return id === node.id;
        });
      }
      this.showed();
    },
    showed() {
      let me = this;
      let indexLine = 0;
      function isParentsOpened(el) {
        if (el.id == 0) return true;
        let parent = me.$_.find(me.flatArborescence, { id: el.idParent });
        if (parent) {
          if (!parent.opened) return false;
          return isParentsOpened(parent);
        }
        return false;
      }
      for (
        let iFlatArborescence = 0;
        iFlatArborescence < this.flatArborescence.length;
        iFlatArborescence++
      ) {
        const el = this.flatArborescence[iFlatArborescence];
        if (this.nodeOpened.indexOf(el.id) >= 0 && el.type === "node") {
          el.opened = true;
        }
        el.showed = false;
        if (el.id == 0) {
          el.showed = true;
          el.indexLine = indexLine;
        }
        if (isParentsOpened(el)) {
          el.showed = true;
          el.indexLine = indexLine++;
        }
      }
      this.$forceUpdate();
    },
    editLine(fa_id, level, name) {
      this.$router.push(this.path + "/family/edit/" + fa_id);
      this.$refs.familywinedit.open(fa_id, level, name, this.ca_id);
    },
    addProductToNode(fa_id, node, name) {
      this.$refs.catalogaddproduct.open(fa_id, node, name, this.ca_id);
    },

    async deleteWinProduct() {
      // let response =
      await this.$axios.delete(
        this.$config.server_url + "/api/1.0/Products/" + this.prIdToDelete
      );
      this.confirmDeleteProduct = false;
      this.getCatalog();
    },
    close(node) {
      node.opened = false;
      for (let ich = 0; ich < node.children.length; ich++) {
        this.close(node.children[ich]);
      }
    },

    listProducts(child) {
      if (child.opened) {
        for (let ich = 0; ich < child.products.length; ich++) {
          const product = child.products[ich];
          this.indexLine++;
          product.indexLine = this.indexLine;
        }
      }
    },

    rerender() {
      this.updatenow = Math.random();
      this.selectedNodeToAdd = [];
      this.addNodeSelected(this.arborescence);
    },
    removeAllMove() {
      let els = document.getElementsByClassName("dnd-parent-ok");
      for (let iEls = 0; iEls < els.length; iEls++) {
        const el = els[iEls];
        el.classList.remove("dnd-parent-ok");
      }
    },
    checkMove(evt) {
      // let item = evt.draggedContext.element;
      this.removeAllMove();
      let node = this.flatArborescence[evt.draggedContext.index];
      let { parentNode } = this.findParentNode(
        node,
        evt.draggedContext.futureIndex
      );
      if (parentNode) {
        let line = document.getElementById("node_" + parentNode.id);
        line.classList.add("dnd-parent-ok");
      }
    },
    findParentNode(node, evtNewIndex) {
      let parentNode = null;
      let newIndex = 0;
      for (let iel = evtNewIndex - 1; iel >= 0; iel--) {
        const element = this.flatArborescence[iel];
        if (element.type === "node" && element.opened) {
          parentNode = element;
          break;
        }
        if (element.showed && node.type == element.type) newIndex++;
      }
      return { parentNode, newIndex };
    },
    async dragEnd(event) {
      this.removeAllMove();
      let node = this.flatArborescence[event.newIndex];
      let { parentNode, newIndex } = this.findParentNode(node, event.newIndex);
      if (parentNode) {
        let body = {
          item: node.type === "node" ? node.id : node.pr_id,
          idTo: parentNode.id,
          newIndex: newIndex,
          type: node.type
        };
        // let response =
        await this.$axios.put(
          this.$config.server_url +
            "/api/1.0/catalogs/" +
            this.ca_id +
            "/draganddrop",
          body
        );
        this.getCatalog();
      }
    },
    deleteNodeNotSelected(node, tabNode, index) {
      if (!node.checked) {
        tabNode.splice(index, 1);
      } else {
        for (let ino = 0; ino < node.children.length; ino++) {
          const child = node.children[ino];
          // let nodeChecked =
          this.deleteNodeNotSelected(child, node.children, ino);
        }
      }
      return node;
    },
    addNodeSelected(node) {
      if (node.checked) {
        let nodeClone = this.$_.cloneDeep(node);
        let nodesChecked = this.deleteNodeNotSelected(nodeClone, []);
        this.selectedNodeToAdd.push(nodesChecked);
      } else {
        for (let ipr = 0; ipr < node.children.length; ipr++) {
          const ichild = node.children[ipr];
          this.addNodeSelected(ichild);
        }
      }
      this.$emit("majTabselectedNodeToAdd", this.selectedNodeToAdd);
    },
    deleteWinConfirm(node) {
      if (!node.id) {
        this.deleteWinConfirmProduct(node);
        return;
      }
      if (node.level === 1) this.nodeTodelete = "la famille " + node.name;
      if (node.level === 2) this.nodeTodelete = "la sous-famille " + node.name;
      if (node.level === 3) this.nodeTodelete = "le segment " + node.name;
      this.faIdToDelete = node.id;
      this.confirmDeleteNode = true;
    },
    deleteWinConfirmProduct(product) {
      this.productTodelete = product.pr_name_fr;
      this.prIdToDelete = product.pr_id;
      this.confirmDeleteProduct = true;
      //  this.listNode();
    },
    async deleteWinNode() {
      // let response =
      await this.$axios.delete(
        this.$config.server_url + "/api/1.0/families/" + this.faIdToDelete
      );
      this.confirmDeleteNode = false;
      this.getCatalog();
      this.$emit("treeloaded", this.arborescence);
      this.$emit("changeDataCatalog");
      //this.listNode();
    }
  }
};
</script>
<style lang="scss" >
.tablestriped-matrice > div:first-child {
  //header
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  div {
    width: 30%;
    font-size: 13px;
    text-transform: uppercase;
    font-weight: 700;
  }
  div:first-child {
    padding-left: 120px;
  }
}
.tablestriped-matrice > div:nth-child(2) {
  div {
    text-align: left;
  }
  .ligne {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 5px;
    padding-bottom: 6px;
    border-bottom: 1px solid #bbb9b9;
    padding-left: 20px;
    //background-color: #adaaaa;
  }
}
.line {
  border-bottom: #d2d2d2 solid 0.5px;
}
.lineNode {
  padding: 5px;
}
.lineProduct {
  padding: 7px;
}
.whiteLine {
  background-color: #fff;
}
.grayLine {
  background-color: #f1f1f1;
}
.dnd-parent-ok {
  background-color: #c3d63e;
}
.selected {
  background-color: #a1a1a1 !important;
}
.handle {
  float: left;
  padding-top: 8px;
}
.align-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.family-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 80%;
}

.nombre-product {
  text-align: center;
  margin-right: auto;
}
.product-name {
  display: flex;
  flex-direction: row;
}
.checkbox-node-line {
  margin: 0 0 0 30px;
  padding: 0;
}
.col-problems {
  align-items: center;
}
.dropdown-pb {
  background-color: #fff;
  padding: 10px;
}
</style>